import React, { DragEvent } from "react";
import {
    IMessageItem,
    MessageType,
} from "../chats-panel/~store/models/MessageItem";
import MessageItem from "src/app/chats-panel/MessageItem/MessageItem";
import { OperatorStatusType } from "../chats-panel/~store/state/ChatItemsState";
import { IChatItem } from "../chats-panel/~store/models/ChatItem";
import { useEffect, useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
    IOperatorItem,
    OperatorType,
} from "../chats-panel/~store/models/OperatorItem";
import {
    HEIGHT_OF_OPERATORITEM_IN_REM,
    HEIGHT_OF_NO_OPERATORS_DIV_IN_REM,
    HEIGHT_OF_DROPDOWN_HEADER_IN_REM,
    HEIGHT_OF_LOADER_IN_REM,
    INPUT_LINES_COUNT,
    INPUT_SYMBOLS_COUNT,
    WECHAT_INPUT_SYMBOLS_COUNT,
    SUPPORTED_EDIT_CHANNELS
} from "./ChatConstants";
import { NavLink, Link } from "react-router-dom";
import ChooseFileDialog, {
    FileType,
} from "src/app/shared/components/choose-file-dialog/ChooseFileDialog";
import CommentDialog from "./comment-dialog/CommentDialog";
import PreviewFileDialog from "src/app/shared/components/preview-file-dialog/PreviewFileDialog";
import {
    showErrorToastr,
    showInfoToastr,
} from "src/app/shared/helpers/toastr-helper/ToastrHelper";
import { ChannelType } from "src/app/contact/~store/models/ChannelType";
import MessageEditor from "./message-editor/MessageEditor";
import { getIsFileImage } from "src/app/shared/helpers/file-helper/FileFormatHelper";
import { PermissionType } from "src/app/shared/components/user-context/models/PermissionType";
import { ChatPanelRuleHelper } from "src/app/shared/helpers/rule-helper/ChatPanelRuleHelper";
import QuickAnswerDialog, {
    QuickAnswerDialogRef,
} from "./quick-answer-dialog/QuickAnswerDialog";
import { DELETED_MESSAGE_MESSAGE } from "./message-editor/message-editor-constants/MessageEditorConstants";
import TransferInviteDialog from "./transfer-invite-dialog/TransferInviteDialog";
import { Spinner } from "reactstrap";
import { ActionType } from "./transfer-invite-dialog/~types/TransferInviteDialogProps";
import { getDateTime } from "src/app/shared/helpers/date-helper/DateFormats";
import SilentChatButton from "./../shared/components/silent-chat-button/SilentChatButton";
import { TOGGLE_SILENT_CHAT_SUCCESS } from "./../chats-panel/~store/actions/~types";
import { IChatProps } from "./~types/ChatProps";
import { useNavigate } from "react-router-dom";
import {
    availableBotsTransferToSelector,
    availableContactTagsSelector,
    availableTiersSelector,
    canSendMessageSelector,
    channelSettingSelector,
    chatDraftSelector,
    chatHistoryContainerSelector,
    chatMessagePreviewSelector,
    contactAvatarIdSelector,
    contactNameSelector,
    contactExternalIdSelector,
    contactTagsSelector,
    isContactOnlineSelector,
    isReceivingAvailibletiersSelector,
    isReceivingOnlineOperatorsSelector,
    isReceivingOnlineOperatorsToInviteSelector,
    isReceivingQuickAnswersSelector,
    messageToEditSelector,
    messegesSelector,
    onlineOperatorsSelector,
    onlineOperatorsToInviteSelector,
    operatorAvatarIdSelector,
    operatorChannelsSelector,
    operatorCurrentChatTextSelector,
    operatorMessageContentTypeSelector,
    operatorIdSelector,
    operatorNameSelector,
    operatorsStatusListSelector,
    operatorStatusSelector,
    permissionsSelector,
    quickAnswersSelector,
    selectedChatIdSelector,
    selectedChatSelector,
    sendingFilesCountSelector,
    updatingContactTagsSelector,
    sendingMessageSelector,
    searchChatHistoryByMessengerSelector,
    isReceivingChatSelector,
} from "../chats-panel/~store/selectors";
import { IApplicationState } from "src/~store/models/ApplicationState";
import {
    chatsSelector,
    isMessageEditingSelector,
} from "../chats/~store/selector";
import {
    addChatHistory,
    addContactTags,
    changeOperatorChatText,
    changeOperatorMessageContentType,
    clearQuickAnswers,
    closeChat,
    deleteContactTags,
    editMessage,
    sendCommentMessage,
    exportChat,
    getAvailableBotsTransferTo,
    getAvailableTiers,
    getChannelOperators,
    getIsContactOnline,
    getOnlineOperatorsToInvite,
    getOnlineOperatorsToTransfer,
    getQuickAnswers,
    inviteOperatorsToChat,
    isChatSpam,
    joinChat,
    onOpenChat,
    onOperatorSendFileMessage,
    onReadMessages,
    pauseChat,
    removeOperatorFromChat,
    removeQuickAnswer,
    resendMessage,
    sendChatMessage,
    setChatVisibilityToState,
    setMessageToEdit,
    toggleMessageEditing,
    transferChat,
    transferChatToTier,
    unpauseChat,
    toggleSearchChatHistoryByMessenger,
    deleteMessage
} from "../chats-panel/~store/actions/actions";
import { AppThunkAction } from "src/~store/models/AppThunkAction";
import {
    ChangeOperatorChatTextAction,
    GetOnlineOperatorsToInviteAction,
    OnReadMessagesAction,
    UpdateContactTagsAction,
} from "../chats-panel/~store/actions/interfaces";
import { connect, useDispatch, useSelector } from "react-redux";
import "./Chat.css";
import { IChat } from "../chats/~store/models/Chat";
import { selectChat } from "../chats/~store/actions/actions";
import { OperatorPriorityType } from "../chats-panel/~store/models/ChannelItem";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Input from "@mui/material/Input";
import EmojiDialog from "./emoji-dialog/EmojiDialog";
import { useTranslation } from "react-i18next";
import i18n from "src/app/shared/localization/i18n";
import { Avatar } from "@mui/material";
import ContactIcon from "@mui/icons-material/AccountCircle";
import SpecifyChatCloseReasonDialog from "./specify-chat-close-reason-dialog/SpecifyChatCloseReasonDialog";
import { useChatMessagesScroll, useChatsPageHotKeys } from "./hooks";
import ChooseMessageContentTypeDialog from "../shared/components/choose-message-content-type-dialog/ChooseMessageContentTypeDialog";
import { TopicPairContentType } from "../nlp/~store/models/enums/TopicPairContentType";
import PauseChatDialog from "./pause-chat-dialog/PauseChatDialog";
import { PAUSE_CATEGORIES } from "./pause-chat-dialog/~types/PauseChatProps";
import moment from "moment";
import Expire from "../shared/helpers/date-helper/expire/Expire";
import { GET_FILE_BY_ID_API_ROUTE } from "../chats-panel/~api/apiRoutes";
import { useMutationObserver } from "../shared/helpers/custom-hooks/useMutationObserver";
import SpamChatButton from "../shared/components/spam-chat-button/SpamChatButton";
import SendingMessage from "../chats-panel/MessageItem/SendingMessage/SendingMessage";
import { DragAndDropArea } from "../shared/components/drag-and-drop-area";
import { ConvertTextToContent } from "../shared/components/text-to-content/TextToContent";
import { mapSettingsSelector, pauseCategoriesSelector } from "../setting/~store/selector";
import Loader from "src/app/shared/components/loader/Loader";
import { NLP_SEARCH_TOPIC_PATH } from "../AppConstants";
import { ChatType } from "../chats-panel/~store/models/enums/ChatType";
import { getChatTypeName } from "../shared/helpers/chat-name-helper/ChatTypeHelper";
import { isImageTypeSupported } from "../shared/helpers/img-helpers/ImageSupportHelper";
import ChatInfoMessageItem from "./chat-info-message/ChatInfoMessageItem";
import { IChatInfoMessageItem } from "./chat-info-message/~types/ChatInfoMessageProps";
import { IChatMessageItem } from "../chats-panel/MessageItem/~types/MessageItemProps";
import { IInitiateConversationTemplate } from '../chats-panel/~store/models/TemplateItem';
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import { Button, Input as ReactstrapInput} from "reactstrap";
import { GetColorFromString } from "src/app/shared/helpers/contact-avatar-helper/ContactAvatarHelper";
import RecordingDialog, { IRecordingInfo, RecordingType } from "../shared/components/recording-dialog/RecordingDialog";

type ReduxType = ReturnType<typeof mapStateToProps> & IChatProps;
let isVoiceRecording = false;
let opacityState = "hight";
let speechRecognizer: any;

const Chat = (props: ReduxType) => {
    const { t } = useTranslation();
    let lastAuthorName: string = "";
    let lastAuthorChatId: number | null = null;
    const navigate = useNavigate();

    const chatEl = useRef<HTMLDivElement>(null);
    const messageInputRef = useRef<HTMLTextAreaElement>(null);
    const quickAnswerRef = useRef<QuickAnswerDialogRef>(null);
    const hiddenInputRef = useRef<HTMLInputElement>(null);

    const [isSpecifyVisible, setIsSpecifyVisible] = useState(false);
    const [currentFileState, setCurrentFileState] = useState<{
        file: File | undefined;
        type: FileType | undefined;
    }>({ file: undefined, type: undefined });
    const [sendWithDragAndDrop, setSendWithDragAndDrop] = useState<boolean>(false);
    const [drag, setDrag] = useState(false);
    const [prevMessageInputHeight, setPrevMessageInputHeight] = useState(0);

    const silentChatsId = useSelector(
        (state: IApplicationState) => state.chatItemsState.silentChatsId
    );
    const dispatch = useDispatch();

    const { webkitSpeechRecognition } = window as any;

    const canSearchNlp = props.permissions.includes(PermissionType.NLP_Search);
    const canTransferChatPermission = props.permissions.includes(PermissionType.Chats_TransferChats);

    const channelSettingObj = props.channelSetting
        ? JSON.parse(props.channelSetting.value)
        : undefined;

    const locale = "_" + (props.selectedChat?.contact?.locale || "ru-RU");
    const nlpTopicName =
        channelSettingObj && channelSettingObj.NLP_TopicName
            ? channelSettingObj.NLP_TopicName + locale
            : "";
    const nlpAnswerTemplate =
        channelSettingObj && channelSettingObj.NLP_AnswerTemplate
            ? channelSettingObj.NLP_AnswerTemplate + locale
            : "";

    const showSpecifyChatCloseDialog =
        channelSettingObj && channelSettingObj.showSpecifyChatCloseDialog
            ? channelSettingObj.showSpecifyChatCloseDialog === "true"
            : false;

    const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
    const [availableTemplates, setAvailableTemplates] = useState<IInitiateConversationTemplate[]>([]);
    const [selectedTemplateName, setSelectedTemplateName] = useState<string>('');

    const {
        isScrollToBottomVisible,
        isScrollToUpVisible,
        chatScroll,
        calculateSpaceToUpAndToBottom,
        scrollToBottomClicked,
        scrollToUpClicked,
    } = useChatMessagesScroll({
        chatEl,
        chatHistoryContainer: props.chatHistoryContainer,
        isReceivingChat: props.isReceivingChat,
        messages: props.messages,
        searchChatHistoryByMessenger: props.searchChatHistoryByMessenger,
        onAddChatHistory: props.addChatHistory,
        onReadMessages: props.onReadMessages,
        operatorId: props.operatorId,
        selectedChatId: props.selectedChatId,
        selectedChat: props.selectedChat,
    });

    const _onTextOperatorChanged = (
        newText: string,
        isQuickAnswer: boolean = false
    ) => {
        if (props.selectedChatId === 0) return;
        props.changeOperatorChatText(newText);
        if (newText.length < 3) props.clearQuickAnswers();
        if (
            props.isReceivingQuickAnswers === false &&
            newText.length >= 3 &&
            !isQuickAnswer
        ) {
            props.getQuickAnswers(newText);
        }
    };

    const _onVoiceInputChangeText = (textFromSpeechRecognizer: string) => {
        if (props.selectedChatId === 0) return;
        props.changeOperatorChatText(textFromSpeechRecognizer);
    };

    const setMicrophoneOpacity = function () {
        let element = document.getElementById("material-icons mic-button");
        if (element) {
            if (opacityState == "low") {
                element.style.opacity = "1";
                opacityState = "hight";
            } else {
                element.style.opacity = "0.3";
                opacityState = "low";
            }
        }
    };

    const _onVoiceInputActivate = () => {
        if (!isVoiceRecording) {
            isVoiceRecording = true;
            const oldMessage = props.chatDraft;

            speechRecognizer = new webkitSpeechRecognition();
            speechRecognizer.interimResults = true;
            speechRecognizer.maxAlternatives = 1;
            speechRecognizer.lang = "ru-RU";

            let element = document.getElementById("material-icons mic-button");
            let textArea = document.getElementById("textarea");
            element?.setAttribute(
                "class",
                "material-icons mic-button-recording"
            );
            speechRecognizer.start();

            let id = setInterval(setMicrophoneOpacity, 1000);

            speechRecognizer.onresult = function (event: any) {
                if (textArea) {
                    textArea.scrollTop = textArea.scrollHeight;
                }
                let viResult = event.results[event.resultIndex];
                _onVoiceInputChangeText(
                    oldMessage + " " + viResult[0].transcript
                );
            };

            speechRecognizer.onaudioend = function () {
                element?.setAttribute("class", "material-icons mic-button");
                isVoiceRecording = false;
                clearInterval(id);
                if (element) element.style.opacity = "0.7";
            };
        } else {
            speechRecognizer.stop();
            isVoiceRecording = false;
        }
    };

    const _onJoinChat = (): void => {
        if (props.selectedChatId === 0) return;
        if (window.confirm(t("chats.askYouWannaJoinChat"))) {
            props.joinChat(props.selectedChatId);
        }
    };

    const _setChatVisibilityToAll = (value: boolean) => {
        props.setChatVisibility(value);
        props.setChatVisibilityToState(value);
    };

    const _onTransferChat = (redirectedTo: number) => {
        props.transferChat(redirectedTo, props.selectedChatId);
        props.isChatSpam(props.selectedChatId);
        if (
            !props.permissions.includes(PermissionType.Chats_ManageOthersChats)
        ) {
            _setChatVisibilityToAll(false);
        }
    };

    const _onLeaveChat = (): void => {
        if (props.selectedChatId === 0) return;
        if (window.confirm(t("chat.doLeaveChat"))) {
            props.removeOperatorFromChat(
                props.operatorId,
                props.selectedChatId
            );
        }
    };

    const _onInviteButtonClick = (operators: IOperatorItem[]) => {
        props.inviteOperatorsToChat(operators, props.selectedChatId);
    };

    const _removeOperator = (operatorIdToRemove: number, chatId: number) => {
        props.removeOperatorFromChat(operatorIdToRemove, chatId);
    };

    const _onOperatorSendMessage = () => {
        props.clearQuickAnswers();

        if ((props.operatorChatText.length < 1 &&
             props.messages[props.messages.length - 1].messageType !== MessageType.clientMessage) ||
            props.selectedChatId === 0 ||
            (props.operatorChatText.length > 0 &&
             props.operatorChatText.replaceAll(/\r?\n|\r|\s/g, "").length === 0)) {
                return;
        }
        
        props.sendChatMessage(
            props.selectedChatId,
            props.operatorChatText.trim(),
            props.operatorId,
            props.operatorMessageContentType
        );
        props.changeOperatorChatText("");
        setPrevMessageInputHeight(0);
        props.changeOperatorMessageContentType(TopicPairContentType.Text);                
    };

    const _onChatClosing = () => {
        if (showSpecifyChatCloseDialog) {
            setIsSpecifyVisible(true);
        } else {
            props.closeChat(props.selectedChatId, false);
        }
    };

    const _onEditMessageClick = (message: IChatMessageItem) => {
        const currentChannelType = props.selectedChat?.channelType;

        if (currentChannelType && !SUPPORTED_EDIT_CHANNELS.includes(currentChannelType)) {
            showInfoToastr(t("chat.cannotEditMessageWrongChannelType"));
            return;
        }

        props.setMessageToEdit(message);

        if (!props.isEditingMessage) {
            props.toggleMessageEditing();
        }
    }

    const _setMessageRead = (messageId: number) => {
        props.onReadMessages([messageId]);
    };

    const _onInputPasteHandler = (event: any): void => {
        for (const file of event.clipboardData.files) {
            if (getIsFileImage(file.type)) {
                setCurrentFileState({
                    ...currentFileState,
                    file,
                    type: FileType.Image,
                });
            } else {
                setCurrentFileState({
                    ...currentFileState,
                    file,
                    type: FileType.File,
                });
            }
        }
    };

    const _setAllMessagesRead = () => {
        const unreadMessages = props.messages.filter(
            (x) =>
                x.readTimestamp === null &&
                x.messageType === MessageType.clientMessage
        );
        let readMessages: number[] = [];
        for (const um of unreadMessages) {
            readMessages.push(um.messageId);
        }
        if (readMessages.length > 0) {
            props.onReadMessages(readMessages);
        }
    };

    const _focusOnMessageInput = () => {
        messageInputRef.current?.focus();
        const text = messageInputRef.current?.value;
        messageInputRef.current?.setSelectionRange(
            text?.length ?? 0,
            text?.length ?? 0
        );
    };

    const _getChatContent = () => {
        const userInStorage = sessionStorage.getItem("user");
        const customerId =
            userInStorage === null
                ? ""
                : JSON.parse(userInStorage.toString()).customerId;
        const contactAvatarUrl =
            props.contactAvatarId !== null
                ? GET_FILE_BY_ID_API_ROUTE + props.contactAvatarId
                : "";
        const fallbackIconColor = contactAvatarUrl ? "#26a69a" : GetColorFromString(props.contactExternalId);

        let operatorStatus = "";
        switch (props.operatorStatus) {
            case OperatorStatusType.Online:
                operatorStatus = "online-status";
                break;
            case OperatorStatusType.Offline:
                operatorStatus = "offline-status";
                break;
        }

        const _onContactTagsChanged = (
            e: React.SyntheticEvent<Element, Event>,
            value: string[]
        ) => {
            if (!props.updatingContactTags) {
                if (value.length > props.contactTags.length) {
                    const addedTags = value.filter(
                        (v) => !props.contactTags.includes(v)
                    );
                    props.addContactTags(addedTags);
                } else if (value.length < props.contactTags.length) {
                    const removedTags = props.contactTags.filter(
                        (v) => !value.includes(v)
                    );
                    props.deleteContactTags(removedTags);
                }
            }
        };

        const _onEmojiClick = (emojiObject: any) => {
            if (props.operatorChatText.length + emojiObject.native.length <= getInputSymbolMaxCount()) {
                props.changeOperatorChatText(props.operatorChatText + emojiObject.native);
            }
        };

        let chatName =
            props.selectedChat === undefined
                ? ""
                : t("common.chat") +
                  " " +
                  props.selectedChat.chatId?.toString();

        const _isMessageEmpty = (message: IMessageItem): boolean => {
            return (
                (message.text == null ||
                    message.text.replace(/\r?\n|\r|\s/g, "") === "") &&
                (message.fileId == null || message.fileId === "") &&
                (message.imageId == null || message.imageId === "") &&
                message.location == null
            );
        };

        let chatCreated =
            props.selectedChat === undefined
                ? ""
                : getDateTime(new Date(props.selectedChat.timeCreated));
        let offsetY =
            (props.isReceivingOnlineOperators
                ? HEIGHT_OF_LOADER_IN_REM
                : props.onlineOperators.length > 0
                ? props.onlineOperators.length * HEIGHT_OF_OPERATORITEM_IN_REM
                : HEIGHT_OF_NO_OPERATORS_DIV_IN_REM) +
            HEIGHT_OF_DROPDOWN_HEADER_IN_REM +
            "rem";
        let dropdownMenyStyles = {
            position: "absolute" as "absolute",
            top: "3.4rem",
            left: 0,
            transform: `translateY(-${offsetY})`,
        };

        const _getTypingIndicatorDelay = () => {
            let timeout = 0;
            if (props.messagePreview)
                timeout =
                    3000 -
                    moment
                        .duration(
                            moment(new Date()).diff(
                                props.messagePreview.lastUpdate
                            )
                        )
                        .asMilliseconds();
            return timeout > 0 ? timeout : 0;
        };

        const _onResentMessageClick = (message: IMessageItem) => {
            props.sendChatMessage(
                message.chatId,
                message.text,
                props.operatorId,
                message.contentType
            );
        };

        const handlePressEnterOnChatHistory = (
            e: React.KeyboardEvent<HTMLDivElement>
        ) => {
            if (e.key === "Enter") {
                props.toggleSearchChatHistoryByMessenger();
            }
        };

        const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
        const checkedIcon = <CheckBoxIcon fontSize="small" color="success" />;
        let contactConnectionStyle = "";
        if (props.isContactOnline) {
            contactConnectionStyle = " online";
        } else if (props.isContactOnline === false) {
            contactConnectionStyle = " offline";
        }

        const handleOpenChatClick = () => {
            props.onOpenChat(
                props.selectedChat ?? ({} as IChatItem),
                props.operatorId,
                props.operatorStatus,
                undefined,
                (templates) => {
                    if (templates && templates.length > 0) {
                        setAvailableTemplates(templates);
                        setSelectedTemplateName(templates[0].template);
                        setIsTemplateModalOpen(true);
                    }
                }
            );
        };

        const handleSendTemplateClick = () => {
            setIsTemplateModalOpen(false);
            props.onOpenChat(
                props.selectedChat ?? ({} as IChatItem),
                props.operatorId,
                props.operatorStatus,
                selectedTemplateName
            );
        };

        const handleCloseModal = () => {
            setIsTemplateModalOpen(false);
        };

        const _onSendRecording = (recording: IRecordingInfo) => {
            props.onOperatorSendFileMessage(
                recording.recording,
                FileType.File,
                props.selectedChatId,
                props.operatorId,
                recording.type == RecordingType.Audio ? TopicPairContentType.AudioNote : TopicPairContentType.VideoNote,
                recording.metadata,
            );
        };

        return (
            <React.Fragment>
                <table
                    className="chat-container__opertator_menu"
                    id="chat-container__opertator_menu"
                >
                    {!props.isReceivingChat && (
                        <tbody>
                            <tr>
                                <td
                                    rowSpan={3}
                                    className="contact-avatar-container"
                                >
                                    <div
                                        className="hide-chat-panel-button"
                                        tabIndex={0}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                _setChatVisibilityToAll(false);
                                            }
                                        }}
                                    >
                                        <img
                                            alt=""
                                            onClick={() => {
                                                _setChatVisibilityToAll(false);
                                            }}
                                        />
                                    </div>
                                    {props.selectedChat && (
                                        <NavLink
                                            to={
                                                "/contacts/edit-contact/" +
                                                props.selectedChat.contactId
                                            }
                                            tabIndex={0}
                                        >
                                            <Avatar
                                                className={
                                                    "contact-item__contact-avatar" +
                                                    contactConnectionStyle
                                                }
                                                src={contactAvatarUrl}
                                            >
                                                <ContactIcon
                                                    style={{ color: fallbackIconColor }}
                                                />
                                            </Avatar>
                                        </NavLink>
                                    )}
                                </td>
                                <td className="chat-history">
                                    <div
                                        onClick={
                                            props.toggleSearchChatHistoryByMessenger
                                        }
                                    >
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            checked={
                                                props.searchChatHistoryByMessenger
                                            }
                                            inputProps={{
                                                onKeyDown:
                                                    handlePressEnterOnChatHistory,
                                            }}
                                        />
                                        <label>
                                            {t("chat.searchByMessenger")}
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="chat-name-container">
                                    <Link to="/chats">{chatName}</Link>
                                </td>
                                <td>
                                    <div className="silent-chat-wrap">
                                        {!props.selectedChat?.isClosed && (
                                            <SilentChatButton
                                                selectedChatId={
                                                    props.selectedChatId
                                                }
                                                silentChatsId={silentChatsId}
                                                onClick={() =>
                                                    dispatch({
                                                        type: TOGGLE_SILENT_CHAT_SUCCESS,
                                                    })
                                                }
                                            />
                                        )}
                                        <SpamChatButton />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="chat-header-channel-name">
                                        {props.selectedChat?.channel.name} {props.selectedChat?.chatType !== ChatType.Private &&
                                            (`(${getChatTypeName(props.selectedChat?.chatType)})`)}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="contact-name-container">
                                    <span>{props.contactName}</span>
                                </td>
                                <td>
                                    <div>{chatCreated}</div>
                                </td>
                            </tr>
                            {false && (
                                <tr>
                                    <td
                                        rowSpan={1}
                                        colSpan={2}
                                        className="client-tags-container"
                                    >
                                        <div>
                                            <Autocomplete
                                                multiple
                                                style={{
                                                    maxWidth: "40rem",
                                                    maxHeight: "6rem",
                                                }}
                                                size="small"
                                                disableClearable
                                                limitTags={3}
                                                options={
                                                    props.availableContactTags
                                                }
                                                value={props.contactTags}
                                                onChange={_onContactTagsChanged}
                                                disableCloseOnSelect
                                                renderOption={(
                                                    props,
                                                    option,
                                                    { selected }
                                                ) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            icon={icon}
                                                            checkedIcon={
                                                                checkedIcon
                                                            }
                                                            checked={selected}
                                                        />
                                                        {option}
                                                    </li>
                                                )}
                                                renderInput={({
                                                    InputLabelProps,
                                                    ...rest
                                                }) => (
                                                    <TextField
                                                        InputLabelProps={{
                                                            ...InputLabelProps,
                                                            children:
                                                                InputLabelProps as any,
                                                        }}
                                                        {...rest}
                                                        label="Теги"
                                                        size="medium"
                                                        type="button"
                                                    />
                                                )}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
                {props.isReceivingChat && <Loader />}
                <div
                    className="chat-container__scrollable"
                    id="chat-container__scrollable"
                >
                    <i
                        className="material-icons chat-container__arrow-btn"
                        tabIndex={0}
                        onClick={() =>
                            props.selectChat(
                                false,
                                props.chats,
                                props.selectedChat
                            )
                        }
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                props.selectChat(
                                    false,
                                    props.chats,
                                    props.selectedChat
                                );
                            }
                        }}
                    >
                        arrow_back_ios
                    </i>
                    <div
                        ref={chatEl}
                        id="chat-body"
                        className="chat"
                        tabIndex={0}
                        onScroll={chatScroll}
                    >
                        <ul>
                            {props.messages
                            .filter(m => !(m.messageType === MessageType.operatorMessage && (!m.text || m.text.length === 0) && !m.fileId && !m.imageId && !m.location && (!m.buttons || m.buttons.length === 0)))
                            .map((item, index) => {
                                return chatEl.current ? (
                                    <VisibilitySensor
                                        delayedCall={true}
                                        key={`${index}-${item.messageId}`}
                                        containment={chatEl.current}
                                        onChange={(isVisible: boolean) => {
                                            if (
                                                isVisible &&
                                                item.messageType ===
                                                    MessageType.clientMessage &&
                                                item.readTimestamp === null
                                            )
                                                _setMessageRead(item.messageId);
                                            calculateSpaceToUpAndToBottom();
                                            if (
                                                isVisible &&
                                                props.messages[
                                                    props.messages.length - 1
                                                ].messageId === item.messageId
                                            ) {
                                                _setAllMessagesRead();
                                            }
                                        }}
                                    >
                                        <li
                                            key={item.messageId}
                                            id={"message-" + item.messageId}
                                            className={
                                                "chat-container__message-item-container"
                                            }
                                        >

                                            {
                                                item.messageType === MessageType.chatInfoMessage ?
                                                <ChatInfoMessageItem messageItem={item as IChatInfoMessageItem}/> :
                                                <MessageItem
                                                    messageItem={item as IChatMessageItem}
                                                    authorName={_getAuthorName(
                                                        item
                                                    )}
                                                    operatorStatus={props.operatorStatus}
                                                    onRemoveOperator={
                                                        _removeOperator
                                                    }
                                                    operatorId={props.operatorId}
                                                    chatOwnerId={
                                                        props.selectedChat
                                                            ?.operatorId ?? 0
                                                    }
                                                    nlpTopicName={nlpTopicName}
                                                    canSearchNlp={canSearchNlp}
                                                    isSupervisor={props.permissions.includes(
                                                        PermissionType.Chats_ManageOthersChats
                                                    )}
                                                    resendMessage={props.resendMessage}
                                                    selectedChat={props.selectedChat}
                                                    isAuthorChatParticipant={props.chats.find(c => c.chatId === item.chatId)?.invitedOperatorsId.includes(item.operatorId!) ?? false}
                                                    mapSettings={props.mapSettings}
                                                    onEditMessage={_onEditMessageClick}
                                                />
                                            }
                                        </li>
                                    </VisibilitySensor>
                                ) : null;
                            })}
                            {props.sendingMessage &&
                                props.selectedChat &&
                                !props.selectedChat.isClosed && (
                                    <SendingMessage
                                        sendingMessage={props.sendingMessage}
                                        onResendClick={_onResentMessageClick}
                                    />
                                )}
                            {props.messagePreview &&
                                props.messagePreview.text.length > 0 && (
                                    <li
                                        key={`preview-${props.messagePreview.chatId}`}
                                        className={
                                            "chat-container__message-item-container"
                                        }
                                    >
                                        <div className="chat-container__message-preview message-item client-message-type">
                                            <div className="message-preview__text">
                                                {ConvertTextToContent(
                                                    TopicPairContentType.Text,
                                                    props.messagePreview.text,
                                                    false
                                                )}
                                            </div>
                                            <Expire
                                                delay={_getTypingIndicatorDelay()}
                                            >
                                                <div className="typing-indicator">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                            </Expire>
                                        </div>
                                    </li>
                                )}
                        </ul>
                    </div>
                    <i
                        className="material-icons chat-container__arrow-btn"
                        tabIndex={0}
                        onClick={() =>
                            props.selectChat(
                                true,
                                props.chats,
                                props.selectedChat
                            )
                        }
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                props.selectChat(
                                    true,
                                    props.chats,
                                    props.selectedChat
                                );
                            }
                        }}
                    >
                        arrow_forward_ios
                    </i>
                </div>
                {props.sendingFilesCount > 0 && (
                    <div className="chat-container__file_loader">
                        {t("chat.sendingFiles", { sendingFilesCount: props.sendingFilesCount })}
                        <Spinner style={{ margin: "0 0 0 0.5rem", width: "1.4rem", height: "1.4rem" }} />
                    </div>
                )}
                {isScrollToUpVisible && (
                    <div className="chat__scroll-to-up-container">
                        <div
                            className={"chat__scroll-to-up"}
                            onClick={() => scrollToUpClicked()}
                        ></div>
                    </div>
                )}
                {isScrollToBottomVisible && (
                    <div className="chat__scroll-to-bottom-container">
                        <div
                            className={"chat__scroll-to-bottom"}
                            onClick={() => scrollToBottomClicked()}
                        ></div>
                    </div>
                )}
                {showSpecifyChatCloseDialog && isSpecifyVisible && (
                    <SpecifyChatCloseReasonDialog
                        chatId={props.selectedChatId}
                        nlpTopicName={nlpTopicName}
                        isVisible={isSpecifyVisible}
                        setIsVisible={setIsSpecifyVisible}
                        closeChat={props.closeChat}
                    ></SpecifyChatCloseReasonDialog>
                )}
                <div
                    className="chat-container__footer"
                    id="chat-container__footer"
                >
                    <div
                        className="chat-container__opertator_text-input-container"
                        onKeyUp={(event) => {
                            if (!props.isEditingMessage && event.key === "ArrowUp") {
                                let lastOpMessage =
                                    getLastOperatorMessage();

                                if (
                                    lastOpMessage.messageId !== undefined &&
                                    props.operatorChatText.length === 0
                                ) { 
                                    const currentChannelType = props.selectedChat?.channelType;
                                    if (currentChannelType && !SUPPORTED_EDIT_CHANNELS.includes(currentChannelType)) {
                                        showInfoToastr(t("chat.cannotEditMessageWrongChannelType"));
                                        return;
                                    }

                                    props.setMessageToEdit(lastOpMessage);
                                    props.toggleMessageEditing();
                                }
                            }
                        }}
                        onKeyDown={(event) => {
                            if (event.key === "ArrowUp") {
                                if (props.quickAnswers.length > 0) {
                                    quickAnswerRef.current?.onUpArrow();
                                    return;
                                }                                
                            }
                            if (event.key === "ArrowDown") {
                                if (props.quickAnswers.length > 0) {
                                    quickAnswerRef.current?.onDownArrow();
                                    return;
                                }
                            }
                            if (event.key === "Enter") {
                                if (props.quickAnswers.length > 0) {
                                    quickAnswerRef.current?.onChooseQuickAmswer();
                                    return;
                                }
                            }
                        }}
                    >
                        <QuickAnswerDialog
                            ref={quickAnswerRef}
                            clearQuickAnswer={props.clearQuickAnswers}
                            onQuickAnswerClick={(text: string) => {
                                _onTextOperatorChanged(text, true);
                                props.clearQuickAnswers();
                                _focusOnMessageInput();
                            }}
                            quickAnswers={props.quickAnswers}
                            removeQuickAnswer={props.removeQuickAnswer}
                            onBlurInput={() => hiddenInputRef.current?.focus()}
                            onFocusInput={() =>
                                messageInputRef.current?.focus()
                            }
                        />
                        <table className="operator-text-input__table">
                            <tbody>
                                {ChatPanelRuleHelper.canWriteMessages(
                                    props.selectedChat?.isClosed ?? true,
                                    props.selectedChat?.operatorId ?? 0,
                                    props.operatorId,
                                    props.selectedChat?.invitedOperatorsId?.includes(
                                        props.operatorId
                                    ) ?? false,
                                    props.operatorStatus
                                ) && (
                                    <tr className="operator-text-input_line">
                                        <td
                                            className="message-params"
                                            tabIndex={0}
                                        >
                                            {props.selectedChat?.channel
                                                ?.type != 8 &&
                                                props.permissions.includes(PermissionType.Chats_SendFiles) && (
                                                <ChooseFileDialog
                                                    isDisabled={props.isEditingMessage}
                                                    onFileChoosen={(
                                                        file,
                                                        type
                                                    ) => {
                                                        setCurrentFileState({
                                                            ...currentFileState,
                                                            file,
                                                            type,
                                                        });
                                                    }}
                                                />
                                            )}
                                            <PreviewFileDialog
                                                file={currentFileState.file}
                                                type={currentFileState.type}
                                                sendWithDragAndDrop={sendWithDragAndDrop}
                                                resetSendWithDragAndDrop={() => setSendWithDragAndDrop(false)}
                                                onFileSend={() => {
                                                    if (
                                                        currentFileState.file !==
                                                            undefined &&
                                                        currentFileState.type !==
                                                            undefined
                                                    ) {
                                                        props.onOperatorSendFileMessage(
                                                            currentFileState.file,
                                                            currentFileState.type,
                                                            props.selectedChatId,
                                                            props.operatorId,
                                                        );
                                                        setCurrentFileState({
                                                            file: undefined,
                                                            type: undefined,
                                                        });
                                                        _focusOnMessageInput();
                                                    }
                                                }}
                                                onFileClear={() => {
                                                    setCurrentFileState({
                                                        file: undefined,
                                                        type: undefined,
                                                    });
                                                    _focusOnMessageInput();
                                                }}
                                            ></PreviewFileDialog>
                                        </td>
                                        <td className="message-params">
                                            <ChooseMessageContentTypeDialog
                                                operatorMessageContentType={
                                                    props.operatorMessageContentType
                                                }
                                                onMessageContentTypeChoosen={
                                                    props.changeOperatorMessageContentType
                                                }
                                            />
                                        </td>
                                        <td>
                                            <input
                                                tabIndex={-1}
                                                type="button"
                                                className="hidden"
                                                value="hidden"
                                                ref={hiddenInputRef}
                                                onKeyDown={(e) => {
                                                    e.preventDefault();
                                                }}
                                            />
                                            <Input
                                                id="textarea"
                                                tabIndex={0}
                                                className="operator-text-input"
                                                multiline={true}
                                                maxRows={INPUT_LINES_COUNT}
                                                value={props.operatorChatText}
                                                inputRef={messageInputRef}
                                                disabled={
                                                    props.sendingMessage !=
                                                        null &&
                                                    !props.sendingMessage.failed
                                                }
                                                inputProps={{
                                                    maxLength: getInputSymbolMaxCount(),
                                                }}
                                                onFocus={(e) =>
                                                    e.currentTarget.setSelectionRange(
                                                        e.currentTarget.value
                                                            .length,
                                                        e.currentTarget.value
                                                            .length
                                                    )
                                                }
                                                onPaste={_onInputPasteHandler}
                                                onChange={(e) => {
                                                    _onTextOperatorChanged(
                                                        e.target.value,
                                                        false
                                                    );
                                                }}
                                                spellCheck={true}
                                                onKeyDown={(e) => {
                                                    if (
                                                        !e.shiftKey &&
                                                        e.key === "Enter"
                                                    ) {
                                                        _onOperatorSendMessage();
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </td>
                                        {nlpAnswerTemplate.length > 0 && (
                                            <td style={{ width: 35 }}>
                                                <i
                                                    className={
                                                        "material-icons search-answer-template-button" +
                                                        (canSearchNlp
                                                            ? ""
                                                            : " disable-search")
                                                    }
                                                    onClick={() => {
                                                        if (canSearchNlp) {
                                                            navigate(
                                                                `${NLP_SEARCH_TOPIC_PATH}/${nlpAnswerTemplate}`
                                                            );
                                                        }
                                                    }}
                                                >
                                                    manage_search
                                                </i>
                                            </td>
                                        )}
                                        <td style={{ width: 35 }}>
                                            <EmojiDialog
                                                onEmojiClick={_onEmojiClick}
                                            ></EmojiDialog>
                                        </td>
                                        <td style={{ width: 35, maxWidth: 35 }} className={"recording__btn" + (props.selectedChat?.channelType === ChannelType.TelegramPrivate ? "" : " hidden")}>
                                            <RecordingDialog onRecordingSend={_onSendRecording}/>
                                        </td>
                                        <td style={{ width: 35 }}>
                                            {webkitSpeechRecognition ? (
                                                <i
                                                    tabIndex={0}
                                                    className="material-icons mic-button"
                                                    onClick={() => {
                                                        _onVoiceInputActivate();
                                                    }}
                                                    onKeyDown={(e) =>
                                                        e.key === "Enter"
                                                            ? _onVoiceInputActivate()
                                                            : false
                                                    }
                                                    id="material-icons mic-button"
                                                >
                                                    mic
                                                </i>
                                            ) : (
                                                <img alt="" />
                                            )}
                                        </td>
                                        <td style={{ width: 35 }}>
                                            <img
                                                alt=""
                                                tabIndex={0}
                                                className="send-button"
                                                onClick={() => {
                                                    _onOperatorSendMessage();
                                                }}
                                                onKeyDown={(e) =>
                                                    e.key === "Enter"
                                                        ? _onOperatorSendMessage()
                                                        : false
                                                }
                                            />
                                        </td>
                                    </tr>
                                )}
                                {props.isEditingMessage && (
                                    <tr>
                                        <td>
                                            <MessageEditor
                                                messageToEdit={
                                                    props.messageToEdit
                                                }
                                                rowsMax={INPUT_LINES_COUNT}
                                                onClose={
                                                    props.toggleMessageEditing
                                                }
                                                onEdit={props.editMessage}
                                                onChangeHeight={
                                                    _setChatBodyHeight
                                                }
                                                onDelete={props.deleteMessage}
                                                selectedChat={props.selectedChat} 
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="chat-footer" id="chat-footer">
                        {ChatPanelRuleHelper.canTransferChat(
                            props.selectedChat?.isClosed ?? true,
                            props.selectedChat?.operatorId ?? 0,
                            props.operatorId,
                            canTransferChatPermission
                        ) && (
                            <TransferInviteDialog
                                isOpen={isTransferDialogOpen}
                                setIsOpen={setIsTransferDialogOpen}
                                actionType={ActionType.Transfer}
                                operatorsStatusList={props.operatorsStatusList}
                                isReceivingOnlineOperators={
                                    props.isReceivingOnlineOperators
                                }
                                onlineOperators={props.onlineOperators}
                                isReceivingAvailableTiers={
                                    props.isReceivingAvailable
                                }
                                availableTiers={props.availableTiers}
                                availableBotsTransferTo={
                                    props.availableBotsTransferTo
                                }
                                onTransferChat={_onTransferChat}
                                pauseCategories={props.pauseCategories}
                                onTransferChatToTier={(tier) =>
                                    props.transferChatToTier(
                                        tier,
                                        props.selectedChatId
                                    )
                                }
                                getOnlineOperators={() =>
                                    props.getOnlineOperatorsToTransfer(
                                        props.selectedChatId
                                    )
                                }
                                channelId={props.selectedChat?.channelId ?? 0}
                                onlineOperatorsToInvite={
                                    props.onlineOperatorsToInvite
                                }
                                getChannelOperators={props.getChannelOperators}
                                isReceivingOnlineOperatorsToInvite={
                                    props.isReceivingOnlineOperatorsToInvite
                                }
                                getOnlineOperatorsToInvite={() =>
                                    props.getOnlineOperatorsToInvite(
                                        props.selectedChatId
                                    )
                                }
                                getAvailableTiers={() =>
                                    props.getAvailableTiers(
                                        props.selectedChat?.channelId || 0
                                    )
                                }
                                getAvailableBotsTransferTo={() =>
                                    props.getAvailableBotsTransferTo(
                                        props.selectedChat?.channelId || 0
                                    )
                                }
                                onInviteButtonClick={_onInviteButtonClick}
                                onCloseDialog={() => {}}
                            />
                        )}
                        {ChatPanelRuleHelper.canInviteOperator(
                            props.selectedChat?.isClosed ?? true,
                            props.selectedChat?.operatorId ?? 0,
                            props.operatorId,
                            props.permissions.includes(
                                PermissionType.Chats_ManageOthersChats
                            ),
                            props.selectedChat?.operator?.type ??
                                OperatorType.Bot
                        ) && (
                            <TransferInviteDialog
                                isOpen={isInviteDialogOpen}
                                setIsOpen={setIsInviteDialogOpen}
                                operatorsStatusList={props.operatorsStatusList}
                                actionType={ActionType.Invite}
                                isReceivingOnlineOperators={
                                    props.isReceivingOnlineOperators
                                }
                                onlineOperators={props.onlineOperators}
                                isReceivingAvailableTiers={
                                    props.isReceivingAvailable
                                }
                                availableTiers={props.availableTiers}
                                availableBotsTransferTo={
                                    props.availableBotsTransferTo
                                }
                                pauseCategories={props.pauseCategories}
                                onTransferChat={_onTransferChat}
                                onTransferChatToTier={(tier) =>
                                    props.transferChatToTier(
                                        tier,
                                        props.selectedChatId
                                    )
                                }
                                getOnlineOperators={() =>
                                    props.getOnlineOperatorsToTransfer(
                                        props.selectedChatId
                                    )
                                }
                                channelId={props.selectedChat?.channelId ?? 0}
                                onlineOperatorsToInvite={
                                    props.onlineOperatorsToInvite
                                }
                                getChannelOperators={props.getChannelOperators}
                                isReceivingOnlineOperatorsToInvite={
                                    props.isReceivingOnlineOperatorsToInvite
                                }
                                getOnlineOperatorsToInvite={() =>
                                    props.getOnlineOperatorsToInvite(
                                        props.selectedChatId
                                    )
                                }
                                getAvailableTiers={() =>
                                    props.getAvailableTiers(
                                        props.selectedChat?.channelId || 0
                                    )
                                }
                                getAvailableBotsTransferTo={() =>
                                    props.getAvailableBotsTransferTo(
                                        props.selectedChat?.channelId || 0
                                    )
                                }
                                onInviteButtonClick={_onInviteButtonClick}
                                onCloseDialog={() => {}}
                            />
                        )}
                        {ChatPanelRuleHelper.canJoinChat(
                            props.selectedChat?.isClosed ?? true,
                            props.selectedChat?.operatorId ?? 0,
                            props.operatorId,
                            props.permissions.includes(
                                PermissionType.Chats_ManageOthersChats
                            ),
                            props.selectedChat?.invitedOperatorsId?.includes(
                                props.operatorId
                            ) ?? false,
                            props.selectedChat !== undefined &&
                                props.selectedChat.operator !== null
                                ? props.selectedChat.operator.type
                                : OperatorType.Bot
                        ) && (
                            <button
                                onClick={_onJoinChat}
                                className="chat-footer__close-chat"
                            >
                                {t("chat.join")}
                            </button>
                        )}
                        {ChatPanelRuleHelper.canLeaveChat(
                            props.selectedChat?.operatorId ?? 0,
                            props.operatorId,
                            props.selectedChat?.invitedOperatorsId?.includes(
                                props.operatorId
                            ) ?? false,
                            props.selectedChat?.isClosed ?? true
                        ) && (
                            <button
                                onClick={_onLeaveChat}
                                className="chat-footer__close-chat"
                            >
                                {t("chat.leave")}
                            </button>
                            )}
                        {ChatPanelRuleHelper.canOpenChat(
                            props.selectedChat?.isClosed ?? false
                        ) && (
                            <button
                                onClick={handleOpenChatClick}
                                tabIndex={0}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        handleOpenChatClick();
                                    }
                                }}
                                className="chat-footer__close-chat"
                            >
                                {t("chat.continue")}
                            </button>          
                        )}
                        <ModalWindow
                            className="whatsapp-template-modal"
                            isOpen={isTemplateModalOpen}
                            onClose={handleCloseModal}
                            header={<span>{t("chat.selectTemplate")}</span>}
                            body={
                                <div style={{ marginTop: '15px' }}>
                                    <ReactstrapInput
                                        type="select"
                                        name="whatsappTemplate"
                                        className="browser-default"
                                        value={selectedTemplateName}
                                        onChange={(e: any) => setSelectedTemplateName(e.target.value)}
                                    >
                                        {availableTemplates?.map((tpl: any, index: number) => (
                                            <option key={index} value={tpl.template}>
                                                {tpl.template} ({tpl.lang})
                                            </option>
                                        ))}
                                    </ReactstrapInput>
                                </div>
                            }
                            footer={
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', width: '100%' }}>
                                    <Button onClick={handleCloseModal}>{t("common.cancel")} </Button>
                                    <Button onClick={handleSendTemplateClick}> {t("common.send")} </Button>
                                </div>
                            }
                        />
                        {ChatPanelRuleHelper.canCloseChat(
                            props.selectedChat?.operatorId ?? 0,
                            props.operatorId,
                            props.selectedChat?.isClosed ?? false,
                            props.permissions.includes(
                                PermissionType.Chats_ManageOthersChats
                            ),
                            props.selectedChat?.onPause ?? false
                        ) && (
                            <button
                                onClick={() => _onChatClosing()}
                                tabIndex={0}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        _onChatClosing();
                                    }
                                }}
                                className="chat-footer__close-chat"
                            >
                                {t("chat.close")}
                            </button>
                        )}
                        <button
                            className="chat__export-chat-btn"
                            tabIndex={0}
                            onClick={() => {
                                if (window.confirm(t("chat.doExportChat"))) {
                                    props.exportChat(
                                        props.selectedChatId
                                    );
                                }
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    if (
                                        window.confirm(t("chat.doExportChat"))
                                    ) {
                                        props.exportChat(
                                            props.selectedChatId
                                        );
                                    }
                                }
                            }}
                        >
                            {t("chat.export")}
                        </button>
                        {ChatPanelRuleHelper.canSendComment(
                            props.selectedChat?.operatorId ?? 0,
                            props.operatorId,
                            props.selectedChat?.invitedOperatorsId?.includes(
                                props.operatorId
                            ) ?? false,
                            props.permissions.includes(
                                PermissionType.Chats_ManageOthersChats
                            )
                        ) && (
                            <CommentDialog 
                                onCommentSend={props.sendCommentMessage}
                                chatId={props.selectedChatId}
                            />
                        )}
                        {props.selectedChat &&
                            !props.selectedChat.isClosed &&
                            props.selectedChat.operator?.type !=
                                OperatorType.Bot && (
                                <PauseChatDialog
                                    selectedChat={props.selectedChat}
                                    pauseChat={props.pauseChat}
                                    unpauseChat={props.unpauseChat}
                                />
                            )}
                    </div>  
                </div>
            </React.Fragment>
        );
    };

    const _setChatBodyHeight = () => {
        setTimeout(() => {
            let clientHeight = document.body.offsetHeight;
            let footerContainerHeight = document.getElementById(
                "chat-container__footer"
            )?.offsetHeight;
            let headerHeight = document.getElementById(
                "chat-container__opertator_menu"
            )?.offsetHeight;
            let footerButtonsHeight =
                document.getElementById("chat-footer")?.offsetHeight;
            let textarea = document.getElementById("message-to-edit__text");
            textarea!.style.height = `${textarea!.scrollHeight}px`;
            let chatBodyHeight =
                footerContainerHeight !== undefined &&
                headerHeight !== undefined
                    ? clientHeight - footerContainerHeight - headerHeight
                    : 0;
            // chatBodyHeight -= footerButtonsHeight !== undefined ? footerButtonsHeight : 0;
            document
                .getElementById("chat-container__scrollable")
                ?.style.setProperty(
                    "height",
                    chatBodyHeight != 0 ? `${chatBodyHeight}px` : ""
                );
        });
    };

    const _getAuthorName = (message: IMessageItem): string | null => {
        if (message.messageType === MessageType.clientMessage) {

            const authorName =
                ((props.selectedChat?.chatType != ChatType.Private) || props.selectedChat?.channelType === ChannelType.SendPulse) && message.senderName
                    ? message.senderName
                    : props.contactName;

            if (lastAuthorName === authorName) return null;
            lastAuthorName = authorName;
            return authorName;
        }
        
        if (message.messageType === MessageType.operatorMessage) {
            if (message.operatorModel?.isDeleted == true) return "[Removed]";

            const groupOperatorName = message.operatorId === null ?
                (message.senderName ?? props.contactName) + " (Admin)" :
                message.operatorName + " (Bot)";

            let operatorName = props.selectedChat?.chatType == ChatType.Group
                ? groupOperatorName
                : (message.operatorName ?? message.senderName);

            if (lastAuthorChatId !== message.chatId) {
                lastAuthorChatId = message.chatId;
                lastAuthorName = "";
            }                

            if (lastAuthorName === operatorName && lastAuthorChatId === message.chatId) return null;
            lastAuthorName = operatorName;
            return operatorName;
        }
        if (message.messageType === MessageType.clientSystemMessage) {
            lastAuthorName = i18n.t("chats.messageFromSystem");
            return i18n.t("chats.messageFromSystem");
        }
        if (message.forOperatorsOnly) {
            return message?.operatorModel?.name ?? "";
        }
        lastAuthorName = "";
        return null;
    };

    const getContactInfo = () => {
        const operatorAvatarUrl =
            props.contactAvatarId !== null
                ? GET_FILE_BY_ID_API_ROUTE + props.contactAvatarId
                : require("src/app/shared/images/Chat/contact_def.png");
        return (
            <div className="contact-info-container">
                <div className="contact-avatar">
                    <img src={operatorAvatarUrl} alt="" />
                </div>
                <div className="contact-name">{props.contactName}</div>
            </div>
        );
    };

    const getInputSymbolMaxCount =(): number => {
      return props.selectedChat?.channel.type === ChannelType.WeChat 
        ? WECHAT_INPUT_SYMBOLS_COUNT 
        : INPUT_SYMBOLS_COUNT;
    }

    const getLastOperatorMessage = (): IMessageItem => {
        return (
            [...props.messages]
                .reverse()
                .find(
                    (value) =>
                        value.messageType === MessageType.operatorMessage &&
                        value.operatorId === props.operatorId &&
                        !value.isDeleted &&
                        !(
                            value.isEdited &&
                            value.text === DELETED_MESSAGE_MESSAGE
                        ) &&
                        props.selectedChatId == value.chatId
                ) ?? ({} as IMessageItem)
        );
    };

    const {
        isInviteDialogOpen,
        isTransferDialogOpen,
        setIsInviteDialogOpen,
        setIsTransferDialogOpen,
    } = useChatsPageHotKeys({
        openChat: () => {
            props.onOpenChat(
                props.selectedChat ?? ({} as IChatItem),
                props.operatorId,
                props.operatorStatus
            );
        },
        closeChat: () => {
            _onChatClosing();
        },
        exportChat: () => {
            if (window.confirm(t("chat.doExportChat"))) {
                props.exportChat(props.selectedChatId);
            }
        },
    });

    const _onDrop = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const files = Array.from(event?.dataTransfer?.files);
        setDrag(false);
        if (files.length > 1) {
            showErrorToastr(t("error.moreThanOneFile"));
            return;
        }
        if (files.length === 0) {
            showErrorToastr(t("error.incorrectFileType"));
            return;
        }
        const file = files?.[0];
        if (isImageTypeSupported(file.type)) {
            setCurrentFileState({
                ...currentFileState,
                file,
                type: FileType.Image,
            });
        } else {
            setCurrentFileState({
                ...currentFileState,
                file,
                type: FileType.File,
            });
        }
        setSendWithDragAndDrop(true);
    };

    const _onDragOver = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDrag(true);
    };

    const _onDragLeave = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDrag(false);
    };

    useEffect(() => {
        if (props.isEditingMessage) {
            props.toggleMessageEditing();
        }
        if (props.selectedChat?.isClosed === false) {
            _onTextOperatorChanged(props.chatDraft ?? "", false);
        }
        props.changeOperatorMessageContentType(TopicPairContentType.Text);
        props.getIsContactOnline(
            props.selectedChat?.messenger.externalId || ""
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedChatId]);

    useEffect(() => {
        if (props.selectedChat?.isClosed === false) {
            _onTextOperatorChanged(props.chatDraft ?? "", false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedChat?.isClosed]);

    useEffect(() => {
        const chatBodyElement = chatEl.current;
        const messageInputElement = messageInputRef.current;

        if (!chatBodyElement || !messageInputElement) {
            return;
        }

        const resizeHandler = () => {
            const newMessageInputHeight = messageInputElement.offsetHeight;

            const heightDifference = newMessageInputHeight - prevMessageInputHeight;

            if (heightDifference !== 0) {
                chatBodyElement.scrollTop += heightDifference;
                setPrevMessageInputHeight(newMessageInputHeight);
            }
        };

        const observer = new ResizeObserver(resizeHandler);
        observer.observe(messageInputElement);
        setPrevMessageInputHeight(messageInputElement.offsetHeight);

        return () => {
            observer.disconnect();
        };
    }, [props.operatorChatText]);

    useEffect(() => {
        const canWrite = ChatPanelRuleHelper.canWriteMessages(
            props.selectedChat?.isClosed ?? true,
            props.selectedChat?.operatorId ?? 0,
            props.operatorId,
            props.selectedChat?.invitedOperatorsId?.includes(props.operatorId) ?? false,
            props.operatorStatus
        );

        if (canWrite) {
            _focusOnMessageInput();
        }
    }, [
        props.selectedChat, 
        props.operatorId,
        props.operatorStatus,
    ]);

    useMutationObserver(messageInputRef, () => {
        setTimeout(() => {
            scrollToBottomClicked();
        });
    });

    return (
        <div
            className={"chat-container"}
            id={"chat-container"}
            onDragOver={!props.selectedChat?.isClosed ? _onDragOver : undefined}
        >
            {drag && (
                <DragAndDropArea onDragLeave={_onDragLeave} onDrop={_onDrop} />
            )}
            {_getChatContent()}
        </div>
    );
};

const mapStateToProps = (state: IApplicationState, externalProps: any) => {
    return {
        chatDraft: chatDraftSelector(state),
        messages: messegesSelector(state),
        sendingMessage: sendingMessageSelector(state),
        messagePreview: chatMessagePreviewSelector(state),
        operatorChatText: operatorCurrentChatTextSelector(state),
        operatorMessageContentType: operatorMessageContentTypeSelector(state),
        operatorName: operatorNameSelector(state),
        canSendMessage: canSendMessageSelector(state),
        operatorStatus: operatorStatusSelector(state),
        operatorAvatarId: operatorAvatarIdSelector(state),
        contactAvatarId: contactAvatarIdSelector(state),
        contactName: contactNameSelector(state),
        contactExternalId: contactExternalIdSelector(state),
        contactTags: contactTagsSelector(state),
        selectedChat: selectedChatSelector(state),
        selectedChatId: selectedChatIdSelector(state),
        mapSettings: mapSettingsSelector(state),
        channelSetting: channelSettingSelector(state),
        operatorChannels: operatorChannelsSelector(state),
        isReceivingOnlineOperators: isReceivingOnlineOperatorsSelector(state),
        onlineOperators: onlineOperatorsSelector(state),
        availableBotsTransferTo: availableBotsTransferToSelector(state),
        onlineOperatorsToInvite: onlineOperatorsToInviteSelector(state),
        isReceivingOnlineOperatorsToInvite:
            isReceivingOnlineOperatorsToInviteSelector(state),
        isReceivingAvailable: isReceivingAvailibletiersSelector(state),
        availableTiers: availableTiersSelector(state),
        availableContactTags: availableContactTagsSelector(state),
        updatingContactTags: updatingContactTagsSelector(state),
        operatorId: operatorIdSelector(state),
        isEditingMessage: isMessageEditingSelector(state),
        messageToEdit: messageToEditSelector(state),
        isWideMode: externalProps.isWideMode,
        setChatVisibility: externalProps.setChatVisibility,
        permissions: permissionsSelector(state),
        quickAnswers: quickAnswersSelector(state),
        sendingFilesCount: sendingFilesCountSelector(state),
        operatorsStatusList: operatorsStatusListSelector(state),
        isReceivingQuickAnswers: isReceivingQuickAnswersSelector(state),
        searchChatHistoryByMessenger:
            searchChatHistoryByMessengerSelector(state),
        chatHistoryContainer: chatHistoryContainerSelector(state),
        chats: chatsSelector(state),
        isContactOnline: isContactOnlineSelector(state),
        pauseCategories: pauseCategoriesSelector(state),
        isReceivingChat: isReceivingChatSelector(state),
    };
};

const mapDispatchToProps = (dispatch: any): IChatProps => {
    return {
        onOpenChat: (
            chat: IChatItem,
            operatorId: number,
            operatorStatus: OperatorStatusType,
            templateName?: string,
            onTemplateRequired?: (templates: IInitiateConversationTemplate[]) => void
        ) => {
            return dispatch(onOpenChat(chat, operatorId, operatorStatus, templateName, onTemplateRequired));
        },
        onReadMessages: (
            messagesId: number[]
        ): AppThunkAction<OnReadMessagesAction> => {
            return dispatch(onReadMessages(messagesId));
        },
        getOnlineOperatorsToInvite: (
            chatId: number
        ): AppThunkAction<GetOnlineOperatorsToInviteAction> => {
            return dispatch(getOnlineOperatorsToInvite(chatId));
        },
        getOnlineOperatorsToTransfer: (chatId: number) => {
            return dispatch(getOnlineOperatorsToTransfer(chatId));
        },
        getAvailableTiers: (channelId: number) => {
            return dispatch(getAvailableTiers(channelId));
        },
        getAvailableBotsTransferTo: (channelId: number) => {
            return dispatch(getAvailableBotsTransferTo(channelId));
        },
        onOperatorSendFileMessage: (
            file: File,
            type: FileType,
            chatId: number,
            operatorId: number,
            messageContentType: TopicPairContentType | undefined,
            metadata: any | undefined
        ) => {
            return dispatch(onOperatorSendFileMessage(file, type, chatId, operatorId, messageContentType, metadata));
        },
        toggleMessageEditing: () => {
            return dispatch(toggleMessageEditing());
        },
        setMessageToEdit: (messageToEdit: IMessageItem | undefined) => {
            return dispatch(setMessageToEdit(messageToEdit));
        },
        editMessage: (editedMessage: IMessageItem) => {
            return dispatch(editMessage(editedMessage));
        },
        deleteMessage: (messageId: number) => {
            return dispatch(deleteMessage(messageId));
        },   
        toggleSearchChatHistoryByMessenger: () =>
            dispatch(toggleSearchChatHistoryByMessenger()),
        addChatHistory: (
            chatIdStart: number,
            chatsIdUp: number,
            chatsIdDown: number,
            direction: "up" | "down" | "both"
        ) => {
            return dispatch(
                addChatHistory(chatIdStart, chatsIdUp, chatsIdDown, direction)
            );
        },
        clearQuickAnswers: () => {
            return dispatch(clearQuickAnswers());
        },
        removeQuickAnswer: (text: string) => {
            return dispatch(removeQuickAnswer(text));
        },
        exportChat: (chatId: number) => {
            return dispatch(exportChat(chatId));
        },
        getChannelOperators: (operatorsIds: number[], channelId: number) => {
            return getChannelOperators(operatorsIds, channelId);
        },
        inviteOperatorsToChat: (operators: IOperatorItem[], chatId: number) => {
            return inviteOperatorsToChat(operators, chatId);
        },
        transferChat: (redirectedTo: number, chatId: number) => {
            return dispatch(transferChat(redirectedTo, chatId));
        },
        transferChatToTier: (tier: OperatorPriorityType, chatId: number) => {
            return transferChatToTier(tier, chatId);
        },
        changeOperatorChatText: (
            newText
        ): AppThunkAction<ChangeOperatorChatTextAction> => {
            return dispatch(changeOperatorChatText(newText));
        },
        sendCommentMessage: (chatId: number, text: string) => {
            return dispatch(sendCommentMessage(chatId, text));
        },
        changeOperatorMessageContentType: (
            contentType: TopicPairContentType
        ) => {
            return dispatch(changeOperatorMessageContentType(contentType));
        },
        getQuickAnswers: (text: string) => {
            return dispatch(getQuickAnswers(text));
        },
        closeChat: (chatId: number, forcibly: boolean) => {
            return dispatch(closeChat(chatId, forcibly));
        },
        joinChat: (chatId) => {
            return dispatch(joinChat(chatId));
        },
        pauseChat: (chatId: number, pauseCategory: PAUSE_CATEGORIES) =>
            pauseChat(chatId, pauseCategory),
        unpauseChat: (chatId: number) => unpauseChat(chatId),
        setChatVisibilityToState: (value: boolean) => {
            return dispatch(setChatVisibilityToState(value));
        },
        removeOperatorFromChat: (
            operatorIdToRemove: number,
            chatId: number
        ) => {
            return dispatch(removeOperatorFromChat(operatorIdToRemove, chatId));
        },
        sendChatMessage: (chatId, text, operatorId, contentType) => {
            return dispatch(
                sendChatMessage(chatId, text, operatorId, contentType)
            );
        },
        selectChat: (
            isNext: boolean,
            chats: IChat[],
            selectedChatItem: IChatItem | undefined
        ) => dispatch(selectChat(isNext, chats, selectedChatItem)),
        addContactTags: (
            tags: string[]
        ): AppThunkAction<UpdateContactTagsAction> => {
            return dispatch(addContactTags(tags));
        },
        deleteContactTags: (
            tags: string[]
        ): AppThunkAction<UpdateContactTagsAction> => {
            return dispatch(deleteContactTags(tags));
        },
        getIsContactOnline: (messengerExternalId: string) =>
            dispatch(getIsContactOnline(messengerExternalId)),
        isChatSpam: (chatId: number) => dispatch(isChatSpam(chatId)),
        resendMessage: (messageId: number) => dispatch(resendMessage(messageId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
